// Player colours shared by the lobby, the in-game ranking and the results — the same person keeps
// the same colour everywhere. The server assigns a stable index (RemotePlayer.color).
export const PLAYER_COLORS = [
  { bg: 'bg-pink-500', hex: '#ec4899' },
  { bg: 'bg-blue-500', hex: '#3b82f6' },
  { bg: 'bg-green-500', hex: '#22c55e' },
  { bg: 'bg-yellow-500', hex: '#eab308' },
  { bg: 'bg-purple-500', hex: '#a855f7' },
  { bg: 'bg-cyan-500', hex: '#06b6d4' },
  { bg: 'bg-orange-500', hex: '#f97316' },
  { bg: 'bg-red-500', hex: '#ef4444' },
  { bg: 'bg-indigo-500', hex: '#6366f1' },
  { bg: 'bg-teal-500', hex: '#14b8a6' },
  { bg: 'bg-lime-500', hex: '#84cc16' },
  { bg: 'bg-fuchsia-500', hex: '#d946ef' },
  { bg: 'bg-amber-500', hex: '#f59e0b' },
  { bg: 'bg-emerald-500', hex: '#10b981' },
  { bg: 'bg-rose-500', hex: '#f43f5e' },
  { bg: 'bg-violet-500', hex: '#8b5cf6' },
];

export function playerColor(index: number | undefined) {
  return PLAYER_COLORS[(index ?? 0) % PLAYER_COLORS.length];
}
